export const version = 'v1.0.0';
export const downloads = [
  {
    platform: 'downloads.wallet.windows',
    icon: 'windows',
    mobile: false,
    builds: [{
      name: 'downloads.wallet.windowsDaemon',
      architectures: [{
        name: '32bit',
        download: 'https://downloads.skycoin.com/skywallet-daemon/skyhwd-1.0.0-win-x86.zip',
        signature: 'https://downloads.skycoin.com/skywallet-daemon/skyhwd-1.0.0-win-x86.zip.asc',
        filetype: '.zip',
        filesize: '14mb',
      }],
    },
    {
      name: 'downloads.wallet.windowsDaemon',
      architectures: [{
        name: '64bit',
        download: 'https://downloads.skycoin.com/skywallet-daemon/skyhwd-1.0.0-win-x64.zip',
        signature: 'https://downloads.skycoin.com/skywallet-daemon/skyhwd-1.0.0-win-x64.zip.asc',
        filetype: '.zip',
        filesize: '14mb',
      }],
    }],
  },
  {
    platform: 'downloads.wallet.macos',
    icon: 'macos',
    mobile: false,
    builds: [{
      name: 'downloads.wallet.macsDaemon',
      architectures: [{
        name: '',
        download: 'https://downloads.skycoin.com/skywallet-daemon/skyhwd-1.0.0-osx-darwin-x64.pkg',
        signature: 'https://downloads.skycoin.com/skywallet-daemon/skyhwd-1.0.0-osx-darwin-x64.pkg.asc',
        filetype: '.pkg',
        filesize: '14mb',
      }],
    }],
  }, {
    platform: 'downloads.wallet.linux',
    icon: 'linux',
    mobile: false,
    builds: [{
      name: 'downloads.wallet.linuxDaemon',
      architectures: [{
        name: 'arm',
        download: 'https://downloads.skycoin.com/skywallet-daemon/skyhwd_1.0.0_armhf.deb',
        signature: 'https://downloads.skycoin.com/skywallet-daemon/skyhwd_1.0.0_armhf.deb.asc',
        filetype: '.deb',
        filesize: '14mb',
      }],
    }, {
      name: 'downloads.wallet.linuxDaemon',
      architectures: [{
        name: 'amd',
        download: 'https://downloads.skycoin.com/skywallet-daemon/skyhwd_1.0.0_amd64.deb',
        signature: 'https://downloads.skycoin.com/skywallet-daemon/skyhwd_1.0.0_amd64.deb.asc',
        filetype: '.deb',
        filesize: '14mb',
      }],
    }],
  },
];



// WEBPACK FOOTER //
// ./src/components/Downloads/components/WalletDaemon/downloads.js